export  var emails = (window.localStorage.emails) ? JSON.parse(window.localStorage.emails).toString().replace(' ', '').split(',') : [];
export default function localStorage(value) {
    emails.push(value);
    window.localStorage.emails = JSON.stringify(emails);
    var emailsParse = (window.localStorage.emails != undefined) ? JSON.parse(window.localStorage.emails) : 'нет доступных email';
    var emailsSort = String(emailsParse).replace(' ', '').split(',');
    return emailsSort
}